// extracted by mini-css-extract-plugin
export var sectionBlock = "content-section-module--section-block--3QZ_5";
export var sectionBlockInner = "content-section-module--section-block-inner--9ksn0";
export var sectionBlockContent = "content-section-module--section-block-content--2JhHe";